export default "__VITE_ASSET__DM38rfYR__"